import dayjs from 'dayjs'

const EARTH_RADIUS = 6378137

const R = Math.PI / 180.0

const BASE = 1000000.0

export function distance(lat1, lng1, lat2, lng2) {
  let rlat1 = lat1 * R,
    rlat2 = lat2 * R

  let a = rlat1 - rlat2,
    b = (lng1 - lng2) * R

  return Math.round(
    2 *
      Math.asin(
        Math.sqrt(
          Math.pow(Math.sin(a / 2), 2) +
            Math.cos(rlat1) * Math.cos(rlat2) * Math.pow(Math.sin(b / 2), 2)
        )
      ) *
      EARTH_RADIUS
  )
}

export function distanceFromDragon(lat1, lng1, lat2, lng2) {
  return distance(lat1 / BASE, lng1 / BASE, lat2 / BASE, lng2 / BASE)
}

export function timediff(k1, k2) {
  return dayjs(k2, 'YYYY-MM-DD', true).diff(
    dayjs(k1, 'YYYY-MM-DD', true),
    'days'
  )
}

export function div(value) {
  return value / BASE
}

export function keyCmp(k1, k2) {
  const d1 = dayjs(k1, 'YYYY-MM-DD', true),
    d2 = dayjs(k2, 'YYYY-MM-DD', true)
  return d1.isSame(d2) ? 0 : d1.isBefore(d2) ? -1 : 1
}
